import React from 'react';

const About = () => {
    return (
        <section id="about" className="about-section">
            <div className="lg-glass lg-glass--section">
                <span className="section-heading__accent text-center d-block">Sobre mí</span>
                <h2 className="section-heading">Benjamín Méndez</h2>
                <div className="row justify-content-center mt-4">
                    <div className="col-lg-9 col-md-11">
                        <p className="fs-6 fs-md-5 mb-3 text-justify text-white-50">
                            ¡Hola! Soy Benjamín Méndez, estudiante de Ingeniería Civil Industrial. Desde una edad temprana,
                            siempre me ha fascinado la forma en que la ingeniería puede transformar y mejorar nuestro entorno.
                        </p>
                        <p className="fs-6 fs-md-5 mb-3 text-justify text-white-50">
                            En la universidad, me encuentro inmerso en un mundo de desafíos y aprendizaje constante. Disfruto
                            cada día aplicando mis conocimientos en proyectos prácticos y colaborando con mis compañeros en la
                            resolución de problemas complejos.
                        </p>
                        <p className="fs-6 fs-md-5 mb-0 text-justify text-white-50">
                            Mi objetivo va más allá del éxito académico; aspiro a contribuir al desarrollo sostenible y al
                            bienestar social a través de mi futura carrera profesional. Estoy entusiasmado por las oportunidades
                            que el campo de la ingeniería civil industrial tiene para ofrecerme y me siento emocionado por lo
                            que el futuro me depara en este apasionante campo.{' '}
                            <span aria-hidden="true">ヅ</span>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
